import { render, staticRenderFns } from "./indexCreate.vue?vue&type=template&id=3ab5c566&"
import script from "./indexCreate.vue?vue&type=script&lang=ts&"
export * from "./indexCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports